import { each, isEmpty, isString, isPlainObject, isArray } from 'lodash';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stringBuilder = (...args) => {
    let strings = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    args.forEach((arg) => {
        if (isString(arg) && !isEmpty(arg)) {
            strings = [...strings, arg];
        }
        else if (isPlainObject(arg)) {
            each(arg, (value, key) => {
                if (value) {
                    strings = [...strings, key];
                }
            });
        }
        else if (isArray(arg) && !isEmpty(arg)) {
            strings = [...strings, stringBuilder(...arg)];
        }
    });
    return strings.join(' ');
};
